import { render, staticRenderFns } from "./LabelApplicationMethodStatus.vue?vue&type=template&id=283a5d0b&"
import script from "./LabelApplicationMethodStatus.vue?vue&type=script&lang=ts&"
export * from "./LabelApplicationMethodStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports